import { z } from 'zod'

import {
  ADS_BUDGET_TYPE,
  ADS_EXPERIENCE_TYPE,
  BUSINESS_GOALS_TYPE,
  HomeTabQuestions,
  WHAT_CONTENT_TYPE,
  WHERE_CUSTOMERS_SUBSCRIBE_TYPE,
} from 'apps/dashboard/constants/HomeTabConstants'

import { IgUsersValueSchema } from './schemas/igUsersValueSchemas'
import { SegmentInsightsSchema } from './schemas/segmentInsightsSchemas'
import { analyticsWidgetSchema } from './schemas/triggerSchemas'

export const homeTabApiSchemas = {
  getQuestionnaireAnswers: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      answers: z
        .object({
          [HomeTabQuestions.BUSINESS_GOALS]: z.array(z.nativeEnum(BUSINESS_GOALS_TYPE)).optional(),
          [HomeTabQuestions.WHERE_CUSTOMERS_SUBSCRIBE]: z
            .array(z.nativeEnum(WHERE_CUSTOMERS_SUBSCRIBE_TYPE))
            .optional(),
          [HomeTabQuestions.WHAT_CONTENT]: z.array(z.nativeEnum(WHAT_CONTENT_TYPE)).optional(),
          [HomeTabQuestions.ADS_BUDGET]: z.nativeEnum(ADS_BUDGET_TYPE).optional(),
          [HomeTabQuestions.ADS_EXPERIENCE]: z.nativeEnum(ADS_EXPERIENCE_TYPE).optional(),
        })
        .nullable(),
    }),
  },
  getWhatsAppOnboardingData: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      wa_broadcasting_onboarding: z.object({
        created_broadcasts_count: z.number(),
        imported_wa_contacts_count: z.number(),
      }),
    }),
  },
  analyticsWidget: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: analyticsWidgetSchema,
  },
  generateAnalyticsWidgetData: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.undefined(),
  },
  igUsersValueData: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      data: IgUsersValueSchema,
    }),
  },
  segmentInsightsData: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      data: SegmentInsightsSchema,
    }),
  },
}

export type IgUsersValueSchemaType = z.infer<typeof IgUsersValueSchema>
